import { Injectable } from "@angular/core";
import { CanMatch, Router, UrlTree } from "@angular/router";
import { PermissionCheckerService } from "./services/permission/permission-checker.service";

/**
 * Module-level guard for the read surface that Auditors share with
 * Administrators (the `administration` and `reports` lazy modules).
 *
 * Admits ROLE_ADMINISTRATOR and ROLE_AUDITOR. Auditors reach and SEE every
 * admin/report screen but are confined to read-only — the backend enforces
 * read-only (auditors hold only read caps; mutations return 403) and the menus
 * keep mutation controls (create/update/delete) gated on hasRoleAdmin().
 *
 * Kept separate from AdminGuard so the admin-only modules (if any are added)
 * are not silently broadened by including the auditor role here.
 */
@Injectable({ providedIn: 'root' })
export class AdminOrAuditorGuard implements CanMatch {

  constructor(private router: Router, private permissionChecker : PermissionCheckerService) {}

  canMatch(): boolean | UrlTree {
    // TODO NUC-269: module-level persona guard for the admin+reports read surface.
    // No single catalog capability maps to the whole module; the reference gates
    // per-route via data.capability. Left role-gated pending a routing restructure.
    if (this.permissionChecker.hasRoleAdmin() || this.permissionChecker.hasRoleAuditor()) {
      return true;
    }
    return this.router.createUrlTree(['/access-denied']);
  }

}
